import React, { createContext, type ReactElement } from 'react';

interface BoundOptions {
  // Leaflet map padding [left, top] in pixels - adds space between map edge and content
  // Example: [40, 40] adds 40px from left, 40px from top
  paddingTopLeft: [number, number];
  // Leaflet map padding [right, bottom] in pixels
  paddingBottomRight: [number, number];
  animate: boolean;
  // Horizontal shift of map center, useful when accounting for sidebars/panels
  centerOffsetX: number;
}

interface BoundOptionsProviderProps {
  children: ReactElement | null;
  options?: {
    paddingTopLeft?: [number, number];
    paddingBottomRight?: [number, number];
    animate?: boolean;
    centerOffsetX?: number;
  };
}

const defaultOptions: BoundOptions = {
  paddingTopLeft: [40, 40],
  paddingBottomRight: [40, 40],
  animate: false,
  centerOffsetX: 0,
};

export const BoundOptionsContext = createContext<BoundOptions>(defaultOptions);

function BoundOptionsProvider({
  children,
  options = defaultOptions,
}: BoundOptionsProviderProps): React.ReactElement {
  const providerValue = React.useMemo(
    () => ({ ...defaultOptions, ...options }),
    [options]
  );
  return (
    <BoundOptionsContext.Provider value={providerValue}>
      {children}
    </BoundOptionsContext.Provider>
  );
}

export default BoundOptionsProvider;
